import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/layout'
import Welcome from '../components/index/welcome'
import About from '../components/index/about'
import Services from '../components/index/services'
import Courses from '../components/index/course-contents'
import Contact from '../components/index/contact'

export default ({ data }) => {
  const course = data.coursesJson
  return (
    <Layout>
      <Welcome data={course} />
      <main id='main' >
        <About data={course} />
        <Services data={course} />
        <Courses data={course} />
        <Contact />
      </main>
    </Layout>
  )
}

export const courseQuery = graphql`
  query($id: String!) {
    coursesJson(id: { eq: $id }) {
      slug
      title
      pyramid
      heroText
      heroImage
      aboutTopic
      aboutText1
      aboutText2
      aboutPoints
      aboutImage
      techTitle
      techSubtitle
      techTitle1
      techTitle2
      techTitle3
      techTitle4
      techTitle5
      techTitle6
      techDesc1
      techDesc2
      techDesc3
      techDesc4
      techDesc5
      techDesc6
      courseSubtitle
      courseContents
      subContents
    }
  }
`
